<div class="card m-4" #newSystemTermsAndConditions>
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">New System Terms & Conditions</div>
	</div>
	<p-divider></p-divider>
	<ol>
		<li>
			<div class="h4">System Deposit</div>
			<div class="item-detailed-description">
				All FOCUS system orders require a non-refundable 50% deposit to be provided at purchase agreement signing, unless otherwise noted & approved.
				This deposit will be applied to your account and will be reflected on the final system invoice. This deposit is non-refundable and is considered
				payment for consultation services, proposal creation, initial system programming and order processing. Deposits, incremental payments & final
				payment returned to us by your banking institution or credit card issuer will incur a $35 returned payment fee and a 5% default fee.
			</div>
		</li>
		<li>
			<div class="h4">Installation Schedule</div>
			<div class="item-detailed-description">
				Installation scheduling will be coordinated between you and your FOCUS Project Coordinator. FOCUS will make all best efforts to meet your
				preferred installation schedule. Installations occurring on Holidays and/or weekends will incur additional charges. Should you need to
				reschedule an installation, you must contact your Project Coordinator 72 hours in advance. Failure to reschedule within 72 hours will result in
				a rescheduling charge of $360.
			</div>
		</li>
		<li>
			<div class="h4">Network Wiring</div>
			<div class="item-detailed-description">
				Unless otherwise specified above, FOCUS is not contracted to provide structural or infrastructure network wiring. The FOCUS system requires RJ25
				terminated CAT5e network wiring to all POS device placement locations. Consult your FOCUS Project Coordinator or Implementation Consultant for
				restaurant specific wiring information.
			</div>
		</li>
		<li>
			<div class="h4">Menu Programming</div>
			<div class="item-detailed-description">
				Prior to the commencement of programming, a project kickoff meeting between yourself and your FOCUS Implementation Consultant is required.
				Please make sure that your complete and final menu is ready for this meeting. Menus not provided in a timely manner may result in additional or
				programming rush charges. Additionally, we will need a list of all item modifiers along with corresponding upcharges (if applicable). Your FOCUS
				Implementation Consultant can provide details and worksheets to simplify this process. Programming of menu additions not provided during the
				initial menu programming phase may result in additional programming charges.
			</div>
		</li>
		<li>
			<div class="h4">Incidental Charges</div>
			<div class="item-detailed-description">
				You will be responsible for any incidental items required to complete your installation. This may include power strips, additional network
				cables, conduit or wireless equipment (unless otherwise specified). You are also responsible for applicable parking charges incurred by the
				FOCUS Implementation Team while facilitating your project.
			</div>
		</li>
		<li>
			<div class="h4">On-Site Standby Support</div>
			<div class="item-detailed-description">
				As part of your FOCUS System implementation, if noted above, your restaurant will receive On-Site Standby Support by a FOCUS Team Member. This
				support is provided during your initial day(s) using the FOCUS System and is limited to the number of hours contracted. Additional time may be
				purchased at our prevailing On-Site Support Rate. The On-Site Standby Support provided as part of the Professional Services above is for weekday
				on-site standby support only. Weekend on-site standby support is provided at our prevailing Weekend On-Site Support rate. On-Site Standby
				Support is NOT a substitute for proper POS system training. Clients who choose to forego FOCUS System Training may be ineligible to receive
				On-Site Standby Support.
			</div>
		</li>
		<li>
			<div class="h4">Travel Expenses</div>
			<div class="item-detailed-description">
				Installations occurring outside of the counties of Los Angeles, Orange, San Diego and Riverside may incur travel expenses. Your Focus Project
				Coordinator will discuss travel expense options with you prior to installation.
			</div>
		</li>
		<li>
			<div class="h4">Payment Arraignment</div>
			<div class="item-detailed-description">
				You are required to pay the balance due as contracted prior to delivery of the POS System. If the system is being financed, an executed Finance
				Agreement must be in place prior to system delivery. Your account must be current and valid for the system to be activated. Payment at the time
				of restaurant opening is not permitted. Focus POS of Arizona, LLC (dba FOCUS CA) reserves all ownership rights to all products provided by us
				until your account is considered current and valid.
			</div>
		</li>
		<li>
			<div class="h4">Limitation of Liability</div>
			<div class="item-detailed-description">
				Customer's exclusive remedy and Focus POS of Arizona, LLC’s (dba FOCUS CA) entire liability in contact, tort or otherwise, in the event that
				Focus POS of Arizona, LLC (dba FOCUS CA), exercising reasonable diligence and having made repeated efforts is unable to comply with the requires
				as set forth herein, shall be the payment of actual damages incurred, but not to exceed the actual contract price for the item as specified here
				in.
			</div>
		</li>
		<li>
			<div class="h4">​Warranties</div>
			<div class="item-detailed-description">
				FOCUS provides all products listed above in as-is condition. All products are considered new unless otherwise noted. Products may contain
				manufactures warranty. Manufacturer warranty information is available from the manufacturer. FOCUS agrees to assist all customers with active
				Equipment Service Package with the executed of manufacturers warranties when and where applicable.
			</div>
		</li>
		<li>
			<div class="h4">PCI Compliance</div>
			<div class="item-detailed-description">
				Customers are encouraged to utilize FocusPay which features a Validated Point-2-Point Encryption System. Customers who elect to forego FocusPay
				are fully responsible for all Payment Card Industry Compliance Efforts. This includes adherence to the current Payment Application Data Security
				Standards (PCI-PADSS) and the Payment Application Best Practices (PABP). The Focus POS Systems PA-DSS Implementation Guide is available at
				http://bit.ly/377iQfj. All customers choosing to forego the benefits of FocusPay are required to adhere to the Focus PA-DSS Implementation
				Guide. Any modifications made to the POS outside of standard system usage by person other than those employed by Focus POS California is
				considered a breach of compliance and may open you to potential system breaches or vulnerabilities. In any event, you, the merchant, are
				strictly liable for the security of all card holder data maintained in your system. Focus POS of Arizona, LLC (dba FOCUS CA) will not be held
				liable for any breaches of card holder data.
			</div>
		</li>
		<li>
			<div class="h4">Software Updates</div>
			<div class="item-detailed-description">
				Unless otherwise noted above, your FOCUS System comes will be implemented with the latest Generally Available Build of FOCUS. Focus POS Systems
				publishes two Major Releases and six Minor Releases per year. Additionally, Focus POS Systems publishes one Validated Security Release every two
				years as mandated by the Payment Card Industry Counsel. Should you wish to obtain the most recent Validated Security Release or Major Release,
				please contact FOCUS for pricing & availability. FocusCloud and FocusCloud+ customers will receive automatic system updates as those updates
				become Generally Available at no additional cost.
			</div>
		</li>
	</ol>
</div>
